import {
  Importance,
  TransportType,
  ScopeSubType,
  RecipientType,
  Day,
  AdditionalScopeSubType,
} from '@app/shared/modules/notifications/shared/notification.model'

export const TransportLabels = {
  [TransportType.Sms]: 'FIELDS.SMS',
  [TransportType.Email]: 'FIELDS.EMAIL',
  [TransportType.InApp]: 'FIELDS.IN_APP',
} as const

export const DayLabels = {
  [Day.Monday]: 'NOTIFICATIONS.DAYS.MONDAY',
  [Day.Tuesday]: 'NOTIFICATIONS.DAYS.TUESDAY',
  [Day.Wednesday]: 'NOTIFICATIONS.DAYS.WEDNESDAY',
  [Day.Thursday]: 'NOTIFICATIONS.DAYS.THURSDAY',
  [Day.Friday]: 'NOTIFICATIONS.DAYS.FRIDAY',
  [Day.Saturday]: 'NOTIFICATIONS.DAYS.SATURDAY',
  [Day.Sunday]: 'NOTIFICATIONS.DAYS.SUNDAY',
} as const

export const ImportanceLabels = {
  [Importance.Immediately]: 'FIELDS.IMMEDIATELY',
  [Importance.BusinessHours]: 'FIELDS.BUSINESS_HOURS',
  [Importance.Custom]: 'FIELDS.CUSTOM',
} as const

export const ScopeSubTypeLabels = {
  [ScopeSubType.Any]: 'NOTIFICATIONS.SCOPE_SUBTYPE.ANY',
  [ScopeSubType.Vehicle]: 'NOTIFICATIONS.SCOPE_SUBTYPE.VEHICLE',
  [ScopeSubType.Depot]: 'NOTIFICATIONS.SCOPE_SUBTYPE.DEPOT',
  [ScopeSubType.Group]: 'NOTIFICATIONS.SCOPE_SUBTYPE.GROUP',
  [ScopeSubType.Role]: 'NOTIFICATIONS.SCOPE_SUBTYPE.ROLE',
  [ScopeSubType.Team]: 'NOTIFICATIONS.SCOPE_SUBTYPE.TEAM',
  [ScopeSubType.TeamType]: 'NOTIFICATIONS.SCOPE_SUBTYPE.TEAM_TYPE',
  [ScopeSubType.Device]: 'NOTIFICATIONS.SCOPE_SUBTYPE.DEVICE',
  [ScopeSubType.User]: 'NOTIFICATIONS.SCOPE_SUBTYPE.USER',
  [ScopeSubType.UserGroup]: 'NOTIFICATIONS.SCOPE_SUBTYPE.USER_GROUP',
  [ScopeSubType.Asset]: 'NOTIFICATIONS.SCOPE_SUBTYPE.ASSET',
  [ScopeSubType.Sensor]: 'NOTIFICATIONS.SCOPE_SUBTYPE.SENSOR',
  [ScopeSubType.Driver]: 'NOTIFICATIONS.SCOPE_SUBTYPE.DRIVER',
} as const

export const ScopeSubTypeFormControlLabels = {
  [ScopeSubType.Vehicle]: 'FIELDS.SPECIFY_MONITORED_VEHICLES',
  [ScopeSubType.Depot]: 'FIELDS.SPECIFY_MONITORED_DEPOTS',
  [ScopeSubType.Group]: 'FIELDS.SPECIFY_MONITORED_GROUPS',
  [ScopeSubType.Role]: 'FIELDS.SPECIFY_MONITORED_ROLES',
  [ScopeSubType.Team]: 'FIELDS.SPECIFY_MONITORED_TEAM',
  [ScopeSubType.TeamType]: 'FIELDS.SPECIFY_MONITORED_TEAM_TYPES',
  [ScopeSubType.Device]: 'FIELDS.SPECIFY_MONITORED_DEVICES',
  [ScopeSubType.User]: 'FIELDS.SPECIFY_MONITORED_USERS',
  [ScopeSubType.UserGroup]: 'FIELDS.SPECIFY_MONITORED_USER_GROUPS',
  [ScopeSubType.Asset]: 'FIELDS.SPECIFY_MONITORED_ASSET',
  [ScopeSubType.Sensor]: 'FIELDS.SPECIFY_MONITORED_SENSORS',
  [ScopeSubType.Driver]: 'FIELDS.SPECIFY_MONITORED_DRIVERS',
} as const

export const AdditionalScopeSubTypeLabels = {
  [AdditionalScopeSubType.Any]: 'NOTIFICATIONS.SCOPE_SUBTYPE.ANY',
  [AdditionalScopeSubType.All]: 'NOTIFICATIONS.SCOPE_SUBTYPE.ANY',
  [AdditionalScopeSubType.Area]: 'NOTIFICATIONS.SCOPE_SUBTYPE.AREA',
  [AdditionalScopeSubType.AreaGroup]: 'NOTIFICATIONS.SCOPE_SUBTYPE.DEPOT',
} as const

export const AdditionalScopeSubTypeFromControlLabels = {
  [AdditionalScopeSubType.Area]: 'FIELDS.SPECIFY_MONITORED_AREAS',
  [AdditionalScopeSubType.AreaGroup]: 'FIELDS.SPECIFY_MONITORED_AREA_GROUPS',
} as const

export const RecipientFormControlLabels = {
  [RecipientType.UserList]: 'FIELDS.SPECIFY_NOTIFIED_USERS',
  [RecipientType.Role]: 'FIELDS.SPECIFY_NOTIFIED_ROLES',
  [RecipientType.UserGroupList]: 'FIELDS.SPECIFY_NOTIFIED_USER_GROUPS',
} as const

export const RecipientAcknowledgeFormControlLabels = {
  [RecipientType.UserList]: 'FIELDS.SPECIFY_ACKNOWLEDGE_USERS',
  [RecipientType.Role]: 'FIELDS.SPECIFY_ACKNOWLEDGE_ROLES',
  [RecipientType.UserGroupList]: 'FIELDS.SPECIFY_ACKNOWLEDGE_USER_GROUPS',
} as const

export const RecipientLabels = {
  [RecipientType.Any]: 'NOTIFICATIONS.RECIPIENTS.ANY',
  [RecipientType.UserList]: 'NOTIFICATIONS.RECIPIENTS.USER',
  [RecipientType.Role]: 'NOTIFICATIONS.RECIPIENTS.ROLE',
  [RecipientType.UserGroupList]: 'NOTIFICATIONS.RECIPIENTS.USER_GROUP',
} as const
